import { All } from "./All";
import { Detail } from "./Detail";
import { Edit } from "./Edit";
import { Create } from "./Create";

const routes = [
    { route: "/create", component: Create },
    { route: "/:customerCategoryId/edit", component: Edit },
    { route: "/:customerCategoryId", component: Detail },
    { route: "/", component: All }
];

export default routes;
